export default __webpack_public_path__ + "static/wijkpaspoort-636c81ad686cf6d31989545a2061f544.png";